import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiClient from './ApiClient';

const wasteCategoriesAPI = createSlice({
	name: 'wasteCategoriesAPI',
	initialState: {
		list: [],
		categories: [],
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchWasteCategoriesPage.fulfilled, (state, action) => {
				state.list = action.payload;
			})
			.addCase(fetchWasteCategoriesList.fulfilled, (state, action) => {
				state.categories = action.payload;
			});
	},
});

export const fetchWasteCategoriesPage = createAsyncThunk(
	'waste-category/fetch/page',
	async () => {
		const response = await apiClient.get(
			`/api/illegal-dumping-location/waste-type`,
			null,
			{ page: 0, size: 999999 },
			'',
			''
		);
		return response.data.content;
	}
);

export const fetchWasteCategoriesList = createAsyncThunk(
	'waste-category/fetch/list',
	async ({ page, filter, sort }) => {
		const response = await apiClient.get(
			`/api/illegal-dumping-location/waste-type`,
			null,
			page,
			filter,
			sort
		);

		if (response.data.content?.length > 0) {
			const _response = [];
			response.data.content.map(({ code, nameInternal }) => {
				_response.push({ code, name: nameInternal });
			});
			response.data.content = _response;
		}

		return response.data;
	}
);

export default wasteCategoriesAPI.reducer;
